import React, { memo, useCallback, useEffect, useMemo, useState } from "react";
import { Card, Input, Controller, Button, SelectBox } from "components/src";
import { useTranslation } from "react-i18next";
import { FormProvider, useForm } from "react-hook-form";
import { Form, Switch, message } from "antd";
import {
  useGetAdminUsersList,
  useGetAuthorityFindCategory,
  useGetAuthorityFindRoles,
  usePostAdminAddNewChannel,
} from "core";

const TITLE = "title";
const ISMANDATORY = "isMandatory";
const ADMINS = "admins";
const ROLES="roles";
const USERCATEGORIESNAME="userCategoriesName";
const ADMINISTRATOR="administrator";
const SUPERVISOR="supervisor";

const layout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 16 },
};


const AddChannel = memo(() => {
  const { i18n } = useTranslation();
  const [messageApi, contextHolder] = message.useMessage();
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);

  const handleChange = (user:any) => {
    setSelectedOptions(user);
  };

  

  const methods = useForm({
    defaultValues: {
      userCategoriesName: [],
      title: "",
      users: [],
      admins: [],
      isMandatory: false,
      administrator:"",
      supervisor:"",
      roles:[]
    },
  });



  const { data } = useGetAdminUsersList({ pageNumber: "1", pageSize: "2000" });
  const options = useMemo((): any[] => {
    return data?.data.users?.map((item: any) => {
      return {
        value: item?.userName,
        label: item?.nameAndFamily,
      };
    });
  }, [data]);


  const adminsArray = options?.filter((item:any) => selectedOptions.includes(item.value));

  

  const { data:roleData, isFetching } = useGetAuthorityFindRoles({
    pageSize: "3000",
    pageNumber: "1",
  });

  const {data:categoriesData}=useGetAuthorityFindCategory(
    {
      pageNumber:"1",
      pageSize:"1000"
    }
  )

  const rolesItem = roleData?.data?.roles?.map((item: { name: string }) => {
    return {
      value: item.name,
      label: item.name,
    };
  });

  const categoriesItem = categoriesData?.data?.categories?.map((item:any) => {
    return {
      value: item.id,
      label: item.name,
    };
  });
  

  const { mutate, isPending } = usePostAdminAddNewChannel({
    onSuccess: () => {
      reset();
      messageApi.open({
        type: "success",
        content: i18n.t("done"),
      });
      setSelectedOptions([])
    },
    onError:()=>{
      messageApi.open({
        type: "error",
        content: i18n.t("duplicateAdmin"),
      });
    }
  });

  const { handleSubmit, reset } = methods;

  const onSubmit = useCallback(
    ({
      userCategoriesName,
      title,
      isMandatory,
      admins,
      administrator,
      supervisor,
      roles
    }: {
      title: string;
      isMandatory: boolean;
      admins: any[];
      roles:any[];
      administrator:string;
      supervisor:string;
      userCategoriesName: any[];
    }) => {
      mutate({
        requestBody: {
          ...(userCategoriesName?.length && { adds: userCategoriesName }),
          title,
          isMandatory,
          users: selectedOptions,
          admins: admins,
          administrator:administrator,
          supervisor:supervisor,
          roles:roles,
          userCategoriesName:userCategoriesName

        },
      });
    },
    [selectedOptions]
  );
  

  
  return (
    <>
      {contextHolder}

      <Card title={i18n.t("addChannel")}>
        <FormProvider {...methods}>
          <Form
            {...layout}
            name="nest-messages"
            onFinish={handleSubmit(onSubmit)}
          >
            <Form.Item>
              <Controller
                rules={{ required: i18n.t("isRequired") }}
                name={TITLE}
              >
                <Input placeholder={i18n.t("title")} />
              </Controller>
            </Form.Item>

            <Form.Item>
                 <SelectBox
                 value={selectedOptions}
                 onChange={handleChange}
                  mode="tags"
                  label={i18n.t("userGroupsName")}
                  placeholder={i18n.t("userGroupsName")}
              options={options?.map((option) => ({
                ...option,
                // disabled: option.value === userData?.userName,
              }))}
                />
            </Form.Item>

            <Form.Item>
              <Controller
                name={ADMINS}
              >
                <SelectBox
                  mode="tags"
                  label={i18n.t("GroupAdminsName")}
                  placeholder={i18n.t("GroupAdminsName")}
                 options={adminsArray}
                />
              </Controller>
            </Form.Item>

            <Form.Item>
              <Controller
                name={ROLES}
              >
                <SelectBox
                  mode="tags"
                  label={i18n.t("roles")}
                  placeholder={i18n.t("roles")}
                  options={rolesItem}
                />
              </Controller>
            </Form.Item>

            <Form.Item>
              <Controller
             name={USERCATEGORIESNAME}
              >
                <SelectBox
                  mode="tags"
                  label={i18n.t("category")}
                  placeholder={i18n.t("category")}
                  options={categoriesItem}
                />
              </Controller>
            </Form.Item>


            <Form.Item>
              <Controller
             name={ADMINISTRATOR}
              >
                <SelectBox
                allowClear
                  label={i18n.t("administrator")}
                  placeholder={i18n.t("administrator")}
                  options={adminsArray}
                />
              </Controller>
            </Form.Item>


            <Form.Item>
              <Controller
             name={SUPERVISOR}
              >
                <SelectBox
                allowClear
                  label={i18n.t("supervisor")}
                  placeholder={i18n.t("supervisor")}
                  options={adminsArray}
                />
              </Controller>
            </Form.Item>

            <Form.Item label={i18n.t("mandatory")}>
              <Controller name={ISMANDATORY}>
                <Switch />
              </Controller>
            </Form.Item>

            <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 5 }}>
              <Button
                style={{ width: "100px" }}
                type="primary"
                isLoading={isPending}
                htmlType="submit"
              >
                {i18n.t("done")}
              </Button>
            </Form.Item>
          </Form>
        </FormProvider>
      </Card>
    </>
  );
});
export { AddChannel };
